import { Link } from "react-router-dom";
import { ShieldCheck, Flag, Building2, ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { mediaUrl } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function Trust() {
  const { content, settings } = useSite();
  return (
    <>
      <section data-testid="partnership-section" className="py-16 sm:py-24 bg-white border-y border-line">
        <div className="container-x grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <Reveal>
            <p className="eyebrow mb-4">Partenaire OGC Nice</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase leading-[1.1] text-onyx">
              Le jeu des supporters, avec les Aiglons.
            </h2>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-muted-foreground">
              Douzième Homme — Le Jeu est partenaire de l'OGC Nice. Retrouvez le jeu à la boutique officielle
              OGC Nice et sur le site officiel du club.
            </p>
            <ul className="mt-8 space-y-3">
              {["Partenaire OGC Nice", "Disponible à la boutique OGC Nice", "Disponible sur le site officiel de l'OGC Nice"].map((item) => (
                <li key={item} className="flex items-center gap-3 text-sm sm:text-base font-semibold text-onyx">
                  <ShieldCheck className="w-5 h-5 text-rouge shrink-0" /> {item}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-3 bg-rouge/5 rotate-1" aria-hidden="true" />
              <img src={mediaUrl(settings?.product_photo_url || "/api/uploads/boite-reelle.jpg")} alt="Photo réelle de la boîte Douzième Homme — Édition Nice"
                className="relative w-full max-w-md mx-auto" loading="lazy" />
            </div>
          </Reveal>
        </div>
      </section>

      <section data-testid="made-in-france-section" className="py-14 sm:py-20 bg-sand">
        <div className="container-x flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-10">
          <div className="w-14 h-14 bg-rouge flex items-center justify-center shrink-0">
            <Flag className="w-7 h-7 text-white" />
          </div>
          <Reveal>
            <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight uppercase text-onyx" data-testid="madeinfrance-title">
              {content.madeinfrance_title}
            </h2>
            <p className="mt-2 text-base text-muted-foreground max-w-2xl">{content.madeinfrance_text}</p>
          </Reveal>
        </div>
      </section>

      <section data-testid="corporate-preview-section" className="py-16 sm:py-24">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-8">
            <p className="eyebrow mb-4">{content.corporate_eyebrow}</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase leading-[1.1] text-onyx">
              {content.corporate_title}
            </h2>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-muted-foreground max-w-2xl">{content.corporate_text}</p>
          </Reveal>
          <Reveal className="lg:col-span-4 lg:text-right" delay={0.1}>
            <Link to="/entreprises" data-testid="corporate-preview-cta"
              className="inline-flex items-center gap-2 border-2 border-onyx text-onyx px-8 py-4 text-sm font-bold uppercase tracking-wide hover:bg-onyx hover:text-cream transition-colors">
              <Building2 className="w-4 h-4" /> Offre entreprises <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
